module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAQCAYAAAAI0W+oAAAAAXNSR0IArs4c6QAAANdJREFUOBFj/P//fwMDHQAj0KL/dLCHgYkeloDsGLWI7JAmJ+j2AW17TqqNpFj0HWh4LiMjozOQ1gHiFSRZBkreRICzQDWa6AYDxUKB+A0R+v8zEFD0FyjfDsSs6JbA+EA5CSDeBMR4AT6LHgB12sIMJEQD1SYC8UdctuGyaDFQAx8hw9HlgXrkgHgvNsvQLXoHVBSGbgApfKB+ULGWC8TfgBgOkC3aAxSVIcVQfGqBZqkB8XGYTSCLfgBxERAz4tNIjhzQTGYgrgTinyCLdMkxhBQ9QDv0AAPwhH0Z3f2oAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bottomCurve.png
// module id = 1395
// module chunks = 32